import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedWarehouseSelector($companyId: ID!, $id: ID) {
    warehouses(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        address
        locations
      }
    }
  }
`

export const Query = gql`
  query WarehouseSelector(
    $companyId: ID!,
    $filters: WarehouseFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    warehouses(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        address
        locations
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
